import React from 'react';

const FilterTitle = (props) => {
    return ( 
        <p className='FilterTitle'>
            {props.FilterTitle}
        </p>
     );    
}
 
export default FilterTitle; 